import { createSelector } from 'reselect';

const chatroomSelector = (state: any) => state.chatroom;

export const loadingSelector = createSelector(chatroomSelector, (chatroom) => chatroom.loading);

export const getCurrentChatroomSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.currentChatroom);
export const getchatMessageSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.chatMessageList);
export const getChatroomReadStatusSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.readMessageId);
export const getChatroomKindListSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.chatroomKindList);
export const getChatroomMemberListSelector = createSelector(
  chatroomSelector,
  (chatroom) => chatroom?.chatroomMemberList
);
export const getMessageSearchTextSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.messageSearchText);
export const getEditedMessageIdSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.editedMessageId);
export const getEditedMessageBodySelector = createSelector(chatroomSelector, (chatroom) => chatroom?.editedMessageBody);
export const getDeletedMessageIdSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.deletedMessageId);
export const getDeletedMessageBodySelector = createSelector(
  chatroomSelector,
  (chatroom) => chatroom?.deletedMessageBody
);
export const getDeletedMessageFileFlgSelector = createSelector(
  chatroomSelector,
  (chatroom) => chatroom?.deletedMessageFileFlg
);
export const getNoticeSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.noticeRoomList);
export const fileListModeSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.fileListMode);
export const getFileListSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.fileList);
export const getSearchKindRoomSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.searchKindRoom);
export const exportSignedUrlSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.exportSignedUrl);
export const otherMemberUserListSelector = createSelector(
  chatroomSelector,
  (chatroom) => chatroom?.otherMemberUserList
);
export const modalCloseFlgSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.modalClose);
export const registerChatroomSelector = createSelector(chatroomSelector, (chatroom) => chatroom?.registerChatroom);
